<template>
  <div class="useral-insert-sale-addon">
    <div class="view-side mt-3 sm:mt-0">
      <div class="view-box">
        <div class="view-box-container">
          <div class="general-fields">
            <custom-validate-input :label="$t('sales.addons.labels.name')"
                                   :classes="{'w-full': true}"
                                   align="right"
                                   rtl
                                   :invalid-text="$t('sales.addons.invalidTexts.name')"
                                   :regex="nameRegex"
                                   v-model="saleAddon.name"/>

            <custom-number-input :label="$t('sales.addons.labels.maxSelect')"
                                 :is-empty="true"
                                 :classes="{'w-full': true}"
                                 v-model="saleAddon.maxSelect"/>

            <custom-price-input :label="$t('sales.addons.labels.price')"
                                :classes="{'w-full': true}"
                                v-model="saleAddon.price" />
          </div>

          <vs-row class="select-character-section">
            <span class="title">{{ $t('sales.addons.labels.priceBaseCharacter') }}</span>
            <div class="character-wrapper"
                 v-for="(character, character_index) in charactersList"
                 :key="character_index">
              <div class="character-checkbox">
                <u-checkbox :label="character.character.name" v-model="character.enable" />
              </div>
              <div class="character-checkbox">
                <u-checkbox :label="$t('sales.addons.labels.required')" v-model="character.required" />
              </div>
            </div>
          </vs-row>

        </div>
      </div>
    </div>

    <div class="view-divider"></div>

    <div class="view-table">
      <u-checkbox :label="$t('sales.addons.labels.variablePricing')" v-model="enableVariablePricing" />
      <div class="view-table-container">
        <edit-sale-addon-price :list-data="variablePriceTableData" />
        <div v-if="!enableVariablePricing" class="disable-edit-table"></div>
      </div>
    </div>

    <vs-button v-show="false"
               id="insertSaleAddonBTN"
               @click="sendData"/>
  </div>
</template>

<script>
  import axios from 'axios'
  import CustomValidateInput from '@/components/customInput/customValidateInput'
  import {getCharacters} from "@/http/requests/characters";
  import CustomDialog from '@/components/customDialog/customDialog'
  import {addComma, checkUserPermissions} from '@/assets/js/functions'
  import CustomSelect from '@/components/customSelect/customSelect'
  import CustomPriceInput from "@/components/customInput/customPriceInput"
  import {insertSaleAddon} from "../../../../../http/requests/salesAddons"
  import InsertSaleAddonCharacter from "./insertSaleAddonCharacter";
  import CustomNumberInput from "../../../../../components/customInput/customNumberInput";
  import UCheckbox from "@/components/checkbox/UCheckbox.vue";
  import EditSaleAddonPrice from "@/views/admin/sales/addons/price/edit/editSaleAddonPrice.vue";
  import {getTerms} from "@/http/requests/terms";

  export default {
    name: 'InsertSaleAddon',
    components: {
      EditSaleAddonPrice,
      UCheckbox,
      CustomNumberInput,
      InsertSaleAddonCharacter,
      CustomPriceInput,
      CustomSelect,
      CustomDialog,
      CustomValidateInput
    },
    data() {
      return {
        nameRegex: this.$validator('regex.sale.addon.name'),
        characters: [
          {
            id: null,
            label: this.$t('sales.addons.labels.all')
          }
        ],
        enableVariablePricing: false,
        saleAddon: {
          name: {
            value: '',
            isValid: false
          },
          maxSelect: {
            value: '',
            isValid: true
          },
          price: {
            value: '',
            isValid: false
          },
          character: {
            id: null
          }
        },
        variablePriceTableData: [],
        charactersList: [],
        attributesSelectedValues: {},
        saleAddonCharacterValues: [],
      }
    },
    created() {
      if (checkUserPermissions('character.show')) {
        this.getCharacters()
      }
      this.getTerms()
    },
    methods: {
      getCharacters() {
        getCharacters().then(response => {
          const characters = response.data.data
          this.saleAddonCharacterValues = []
          characters.forEach(character => {
            this.characters.push({
              id: character.id,
              label: character.name
            })
            this.saleAddonCharacterValues.push({
              label: character.name,
              value: {
                id: character.id,
                name: character.name,
                value: character.id
              }
            })
            this.charactersList.push({
              id: 'new',
              price: {
                value: '',
                isValid: false
              },
              enable: false,
              required: false,
              character: {
                id: character.id,
                name: character.name
              }
            })
          })
        })
      },
      checkUserPermissions(permission) {
        return checkUserPermissions(permission)
      },
      getTerms () {
        getTerms().then((response) => {
          const terms = response.data.data
          let rowData = {}
          terms.forEach((term) => {
            if (!rowData[`term_${term.id}`]) {
              rowData[`term_${term.id}`] = {}
            }
            rowData[`term_${term.id}`]['termName'] = term.name || ''
            rowData[`term_${term.id}`]['termId'] = term.id
            rowData[`term_${term.id}`]['flag'] = 'NEW'
            for (let i = 1; i <= 7; i++) {
              rowData[`term_${term.id}`][`day_${i}`] = ''
            }
          })

          const dataArray = Object.values(rowData)
          setTimeout(() => {
            dataArray.forEach((item) => {
              this.variablePriceTableData.push(item)
            })
          }, 100)
        })
      },
      sendData() {
        if (!this.saleAddon.name.isValid) {
          this.$vs.notify({
            title: this.$t('alert.error.title'),
            text: this.$t('sales.addons.validators.name'),
            icon: 'icon-alert-circle',
            iconPack: 'feather',
            time: 2400,
            color: 'danger'
          })
          return false
        } else if (!this.saleAddon.maxSelect.isValid) {
          this.$vs.notify({
            title: this.$t('alert.error.title'),
            text: this.$t('sales.addons.validators.maxSelect'),
            icon: 'icon-alert-circle',
            iconPack: 'feather',
            time: 2400,
            color: 'danger'
          })
          return false
        } else if (this.charactersList.length === 0) {
          this.$vs.notify({
            title: this.$t('alert.error.title'),
            text: this.$t('sales.addons.validators.noCharacter'),
            icon: 'icon-alert-circle',
            iconPack: 'feather',
            time: 2400,
            color: 'danger'
          })
          return false
        } else if (this.saleAddon.price.value.length === 0) {
          this.$vs.notify({
            title: this.$t('alert.error.title'),
            text: this.$t('sales.addons.validators.price'),
            icon: 'icon-alert-circle',
            iconPack: 'feather',
            time: 2400,
            color: 'danger'
          })
          return false
        }

        let characters = []
        this.charactersList.forEach(item => {
          if (item.enable) {
            characters.push({
              character_id: item.character.id > 0 ? item.character.id : null,
              price: this.saleAddon.price.value,
              required: item.required ? 1 : 0
            })
          }
        })

        let dynamicPrices = []

        this.variablePriceTableData.forEach((term) => {
          if (term.flag === 'UPDATED') {
            for (let i = 1; i <= 7; i++) {
              if (term[`day_${i}`]) {
                dynamicPrices.push({
                  week_day: i,
                  term_id: term.termId,
                  price: term[`day_${i}`] ? term[`day_${i}`].replaceAll(',', '') : ''
                })
              }
            }
          }
        })

        let saleAddon = {
          name: this.saleAddon.name.value,
          price: this.saleAddon.price.value,
          max_select: this.saleAddon.maxSelect.value.length > 0 ? this.saleAddon.maxSelect.value : '100',
          characters: characters,
          dynamic_prices: this.enableVariablePricing ? dynamicPrices : null
        }

        if (checkUserPermissions(['character.show', 'user.set_character']) === 2) saleAddon.character_id = this.saleAddon.character.id

        insertSaleAddon(saleAddon).then(() => {
          this.$vs.notify({
            title: this.$t('alert.message.title'),
            text: this.$t('sales.addons.notifications.insert.success'),
            icon: 'icon-check',
            iconPack: 'feather',
            time: 2400,
            color: 'success'
          })
          this.$emit('inserted')
        }).catch((error) => {
          if (axios.isCancel(error)) {
            this.$vs.notify({
              title: this.$t('alert.duplicateRequest.title'),
              text: this.$t('alert.duplicateRequest.message'),
              icon: 'icon-alert-circle',
              iconPack: 'feather',
              time: 2400,
              color: 'warning'
            })
          } else {
            const error_mapper = {
              'name': this.$t('sales.addons.notifications.parseError.name'),
              'price': this.$t('sales.addons.notifications.parseError.price'),
              'character_id': this.$t('sales.addons.notifications.parseError.character'),
              'max_select': this.$t('sales.addons.notifications.parseError.maxSelect')
            }

            switch (error.response.status) {
              case 422:
                Object.keys(error.response.data.errors).forEach((error_key) => {
                  const err = error_key.toString().split('.')
                  if (error_mapper[err[err.length - 1]]) {
                    this.$vs.notify({
                      title: this.$t('alert.error.title'),
                      text: error_mapper[err[err.length - 1]],
                      color: 'danger',
                      icon: 'icon-alert-circle',
                      iconPack: 'feather',
                      time: 2400
                    })
                    error_mapper[err[err.length - 1]] = null
                  }
                })
                break

              default:
                this.$vs.notify({
                  title: this.$t('alert.error.title'),
                  text: this.$t('sales.addons.notifications.insert.error'),
                  color: 'danger',
                  icon: 'icon-alert-circle',
                  iconPack: 'feather',
                  time: 2400
                })
                break
            }
          }
        })
      },

      deleteSaleAddonCharacter(character, index) {
        this.charactersList.splice(index, 1)
      },
    }
  }
</script>

<style lang="scss">
  .useral-insert-sale-addon {
    width: 100%;
    height: calc(100% - 10px);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 10px;

    @media (max-width: 767px) {
      display: block;
    }

    .view-side {
      height: 100%;
      width: 310px;
      /*border: 1px solid #cecece;*/
      /*padding: 5px;*/
      border-radius: .5rem;
      overflow-y: auto;


      @media (max-width: 767px) {
        width: 100%;
        min-width: 100%;
        height: calc(100% - 230px);
      }

      .view-box {
        width: 100%;
        height: 100%;
        overflow: auto;
        direction: rtl;

        .view-box-container {
          direction: ltr;
        }

        .custom-profile-image-input {
          .profile-image-label {
            height: 110px;
            width: 110px;
          }
        }

        .date-picker-item {
          border: 0 !important;
          border-radius: 0.4rem;
          position: relative;

          .date-picker-label {
            font-size: 12px;
            position: absolute;
            top: -10px;
            left: 5px;
            padding: 0 5px;
            background-color: #ffffff;
            z-index: 1;
          }

          .vpd-input-group {
            width: 20px !important;
            position: absolute;
            top: 6px;
            left: 2px;

            .vpd-icon-btn {
              opacity: 1 !important;
              height: 25px !important;
              width: 20px !important;
              background-color: inherit !important;

              svg {
                fill: #000000;
                overflow: visible !important;
              }
            }

            .form-control {
              border: 0;
              width: 100%;
              display: none;
              line-height: 35px;
            }
          }
        }

        .general-fields {
          margin-bottom: 20px;
        }
        .custom-input:last-child {
          margin-bottom: 0;
        }

        .input-field-item {
          position: relative;
          border: 1px solid #cdcdcd;
          border-radius: 0.4rem;
          padding: 5px 10px;
          margin: 15px 0;
          display: flex;
          justify-content: space-around;
          min-height: 35px;
          flex-wrap: wrap;

          &.invalid {
            border-color: #b00000;

            .input-field-label {
              color: #b00000;
            }
          }

          .input-field-label {
            position: absolute;
            font-size: 12px;
            top: -10px;
            left: 8px;
            background-color: #ffffff;
            padding: 0 5px;
          }

          .radio-item {
            display: flex;
            align-items: center;
            width: max-content;
            direction: rtl;

            label {
              direction: ltr;
              margin-left: 5px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          &.character-input {
            justify-content: space-between;

            .radio-item {
              justify-content: flex-end;
              width: 33%;
            }
          }
        }

        div.edit-user-field {
          position: relative;

          span.label {
            font-size: 12px;
            position: absolute;
            top: -10px;
            left: 7px;
            z-index: 10000;
            background: #ffffff;
            padding: 0 5px;
          }

          .useral-custom-element-select {
            margin: 15px 0;

            .selected {
              height: 35px;
              line-height: 35px;
              font-size: 13px;
            }

            .items {
              line-height: 35px;

              div {
                height: 35px;
                font-size: 13px;
              }
            }
          }
        }

        .select-character-section {
          margin-top: 30px;
          padding: 15px 5px 5px;
          border: 1px solid #cdcdcd;
          border-radius: 0.5rem;
          position: relative;
          flex-direction: column;
          gap: 5px;

          .title {
            position: absolute;
            top: -11px;
            left: 5px;
            padding: 0 5px;
            backdrop-filter: sepia(1);
          }

          .character-wrapper {
            display: flex;
            justify-content: space-between;

            &:not(&:last-of-type) {
              border-bottom: 1px solid #cecece;
              padding-bottom: 5px;
            }
          }
        }

        .insert-attribute-btn {
          font-size: 18px;
          position: absolute;
          right: 3px;
          top: -10px;
          bottom: 0;
          margin: auto;
          height: fit-content;
          padding: 6px;
          border-radius: .5rem;
          border: 1px solid #cecece;
          background: #cecece54;
          cursor: pointer;
          z-index: 200;
          transition: all .3s ease;

          &:hover {
            box-shadow: 0 0 10px #cecece;
          }
        }

        .vs-divider {
          margin-bottom: 20px;
          .vs-divider-border.after {
            background-color: unset;
          }
        }

        .error-alert {
          display: inline-block;
          border: 1px solid #ffba00;
          border-radius: .5rem;
          color: #ffba00;
          padding: 0 10px;
          line-height: 50px;
          height: 50px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 15px;

          i {
            font-size: 15px;
          }
        }

        &::-webkit-scrollbar {
          display: block;
          border-radius: .2rem;
          width: 10px;
          background: #f9f9fd;
          right: 10px;
        }

        &::-webkit-scrollbar-thumb {
          display: block;
          border-radius: .2rem;
          background: #cecece;
        }
      }
    }

    .view-divider {
      height: 100%;
      width: 1px;
      background-color: #cecece;
    }

    .view-table {
      width: calc(100% - 340px);
      display: flex;
      flex-direction: column;
      gap: 10px;

      .view-table-container {
        height: calc(100% - 25px);
        position: relative;
        flex: 1;

        .disable-edit-table {
          position: absolute;
          height: 100%;
          width: 100%;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          background: #ffffff;
          opacity: 0.4;
        }
      }
    }

    @media (max-width: 1060px) {
      flex-wrap: nowrap;
      flex-direction: column;

      .view-side {
        width: 100%;
        height: unset;
        overflow-y: unset;

        .view-box {
          overflow: unset;
        }
      }

      .view-table {
        flex: 1;
        width: 100%;
        padding-bottom: 15px;
      }

      .view-divider {
        width: 100%;
        height: 1px;
        min-height: 1px;
      }
    }
  }
</style>
